import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Input, Modal, DatePicker, Radio } from "antd";
import "./style.css";
import { firestore } from "../config/firebase";
import moment from "moment";
import {
  collection,
  getDocs,
  updateDoc,
  getDoc,
  doc,
  deleteDoc,
} from "firebase/firestore";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import GradeIcon from "@mui/icons-material/Grade";
import CircleIcon from "@mui/icons-material/Circle";
import { colors } from "../utils/color";
import DeleteOutlineTwoToneIcon from "@mui/icons-material/DeleteOutlineTwoTone";
import CircularProgress from "@mui/material/CircularProgress";
import EditIcon from "@mui/icons-material/Edit";
import Block from "@mui/icons-material/Block";
import CounsellorForm from "./form";
import "./form.css";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";

const CounsellorList = () => {
  const navigate = useNavigate();
  const [totalRecords, setTotalRecords] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [initialData, setInitialData] = useState([]);
  const [displayedData, setDisplayedData] = useState(initialData.slice(0, 10));
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [isDatePickerVisible, setIsDatePickerVisible] = useState(false);
  const [isStatusModalVisible, setIsStatusModalVisible] = useState(false);
  const { RangePicker } = DatePicker;
  const [statusFilter, setStatusFilter] = useState(null);
  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [order, setOrder] = useState({ name: "asc", total: "asc" });
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState(false);
  const [feedbackComment, setFeebackComment] = useState("");
  const [rating, setRating] = useState([
    {
      id: 1,
      star: false,
    },
    {
      id: 2,
      star: false,
    },
    {
      id: 3,
      star: false,
    },
    {
      id: 4,
      star: false,
    },
    {
      id: 5,
      star: false,
    },
  ]);

  const hideDeleteModal = () => {
    setUserToDelete(null);
    setDeleteModalVisible(false);
  };

  const handleDeleteConfirmed = async () => {
    if (userToDelete) {
      try {
        const userRef = doc(firestore, "councellors", userToDelete);
        const userSnapshot = await getDoc(userRef);
        
        if (userSnapshot.exists()) {
          await deleteDoc(userRef); // This deletes the document
          fetchDataFromFirestore();
          setUserToDelete("");
        } else {
          console.log("councellors not found with ID:", userToDelete);
        }

        hideDeleteModal();
      } catch (error) {
        console.error("Error updating isDeleted:", error);
      }
    }
  };

  const handleFeatureChange = async (record, i, e, key) => {
    const loaderName = key === "isFeatured" ? "featureLoad" : "blockLoad";
    e.stopPropagation();
    setDisplayedData([
      ...displayedData.map((el, index) => {
        if (index === i) {
          el[loaderName] = true;
          return el;
        } else {
          el[loaderName] = false;
          return el;
        }
      }),
    ]);
    const updatedValue = {
      [key]: !record[key],
    };
    try {
      await updateDoc(
        doc(firestore, "councellors", record.phone),
        updatedValue
      );
      fetchDataFromFirestore();
    } catch (error) {
      console.error("Error updating isFeatured:", error);
    }
  };

  useEffect(() => {
    const sortData = (column, order) => {
      const sortedData = [...initialData].sort((a, b) => {
        if (order === "asc") {
          return a[column] > b[column] ? 1 : -1;
        } else {
          return a[column] < b[column] ? 1 : -1;
        }
      });
      return sortedData;
    };

    const sortedData = sortData(selectedItem, order[selectedItem]);

    setDisplayedData(sortedData);
  }, [initialData, order, selectedItem]);

  const loadAllData = () => {
    setDisplayedData(initialData);
    setTotalRecords(initialData.length);
  };

  useEffect(() => {
    fetchDataFromFirestore();
  }, []);

  const fetchDataFromFirestore = async () => {
    try {
      const querySnapshot = await getDocs(collection(firestore, "councellors"));
      const firebaseData = querySnapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((counsellor) => !counsellor.isDeleted);
     
      const updatedFirebaseData = firebaseData.map((counsellor) => {
        const timestampObject = counsellor.dateJoined;

        if (
          timestampObject &&
          timestampObject.seconds &&
          timestampObject.nanoseconds !== undefined
        ) {
          const dateJoined = new Date(
            timestampObject.seconds * 1000 + timestampObject.nanoseconds / 1e6
          );
          return {
            ...counsellor,
            dateJoined: dateJoined.toISOString().split("T")[0],
            delete: false,
            block: false,
            load: false,
            deleteLoad: false,
            featureLoad: false,
          };
        } else {
          return {
            ...counsellor,
            delete: false,
            block: false,
            load: false,
            deleteLoad: false,
            featureLoad: false,
          };
        }
      });

      setInitialData(updatedFirebaseData);
      setDisplayedData(updatedFirebaseData.slice(0, 10));
      setTotalRecords(updatedFirebaseData.length);
    } catch (error) {
      console.error("Error fetching data from Firebase:", error);
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);

    const filteredData = initialData.filter(
      (item) =>
        `${item.firstName} ${item.lastName}`
          .toLowerCase()
          .includes(value.toLowerCase()) ||
        item.firstName.toLowerCase().includes(value.toLowerCase()) ||
        item.lastName.toLowerCase().includes(value.toLowerCase()) ||
        item.id.toLowerCase().includes(value.toLowerCase()) ||
        item.email.toLowerCase().includes(value.toLowerCase()) ||
        item.city.toLowerCase().includes(value.toLowerCase()) ||
        item.state.toLowerCase().includes(value.toLowerCase()) ||
        item.phone.includes(value)
    );
    setDisplayedData(filteredData);
    setTotalRecords(filteredData.length);
  };

  const handleDateFilter = (dates, dateStrings) => {
    if (dates) {
      const startDate = dates[0].format("YYYY-MM-DD");
      const endDate = dates[1].format("YYYY-MM-DD");
      const filteredData = initialData.filter((item) => {
        const itemDate = moment(item.dateJoined).format("YYYY-MM-DD");
        const result = moment(itemDate).isBetween(
          startDate,
          endDate,
          null,
          "[]"
        );
        if (result) return item;
      });
      setDisplayedData(filteredData);
      setTotalRecords(filteredData.length);
      setIsDatePickerVisible(false);
      setFiltersApplied(true);
    }
  };

  const handleDatePickerClick = () => {
    setIsDatePickerVisible((prevState) => !prevState);
    rollbackRadioOption();
  };

  const handleStatusClick = () => {
    setIsStatusModalVisible((prevState) => !prevState);
    rollbackRadioOption();
  };
  
  const handleStatusFilterChange = (e) => {
    const selectedStatus = e.target.value;
    setStatusFilter(selectedStatus);
    const filteredCounselors = initialData.filter((counsellor) => {
      if (selectedStatus == "active" && counsellor.status) return counsellor;
      else if (selectedStatus == "inactive" && !counsellor.status)
        return counsellor;
      else if (selectedStatus == "blocked" && counsellor.isBlocked)
        return counsellor;
    });
    setDisplayedData(filteredCounselors);
    setTotalRecords(filteredCounselors.length);
    setFiltersApplied(true);
    handleStatusClick();
  };

 
  const handleFeaturedCounsellorClick = () => {
    const featuredCounselors = initialData.filter(
      (counselor) => counselor.isFeatured
    );
    setDisplayedData(featuredCounselors);
    rollbackRadioOption();
    setFiltersApplied(true);
  };

  const handleDeleteAll = async () => {
    setDeleteModalVisible(!isDeleteModalVisible);
  };

  const shouldRenderViewAllButton = displayedData.length > 10;

  const clearFilters = () => {
    setStatusFilter(null);
    fetchDataFromFirestore();
    setFiltersApplied(false);
  };

  const handleMapArray = (id, e) => {
    e.stopPropagation();
    setDisplayedData([
      ...displayedData.map((el, index) => {
        if (index === id) {
          return { ...el, delete: !el?.delete };
        } else return el;
      }),
    ]);
  };

  const toggleDeleteSwitch = () => {
    if (
      displayedData.some((el, index) => el.delete) &&
      !displayedData.every((el, index) => el.delete)
    ) {
      setDisplayedData([
        ...displayedData.map((el) => {
          el.delete = true;
          return el;
        }),
      ]);
    } else if (displayedData.every((el, index) => el.delete)) {
      setDisplayedData([
        ...displayedData.map((el) => {
          el.delete = false;
          return el;
        }),
      ]);
    } else {
      setDisplayedData([
        ...displayedData.map((el) => {
          el.delete = !el.delete;
          return el;
        }),
      ]);
    }
  };

  const getRatingFromAdmin = (index) => {
    const newRating = rating.map((el, i) => {
      if (i <= index) {
        return { ...el, star: true };
      } else {
        return { ...el, star: false };
      }
    });
    setRating(newRating);
  };
  const [open, setOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const handleOptionChange = (event) => {
    setFilterOption([
      ...filterOption.map((e) => {
        if (e.value == event.target.value) {
          return { ...e, checked: true };
        } else return { ...e, checked: false };
      }),
    ]);
    setSelectedOption(event.target.value);
    switch (event.target.value) {
      case "joiningDate":
        handleDatePickerClick();
        break;
      case "active":
        handleStatusClick();
        break;
      case "featured":
        handleFeaturedCounsellorClick();
        break;
     
    }
  };

  const rollbackRadioOption = () => {
    setFilterOption([
      ...filterOption.map((e) => {
        return { ...e, checked: false };
      }),
    ]);
    setOpen(false);
    setSelectedOption("");
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [filterOption, setFilterOption] = useState([
    {
      name: "Joining Date",
      checked: false,
      id: 1,
      value: "joiningDate",
    },
    {
      name: "Active",
      checked: false,
      id: 2,
      value: "active",
    },
    {
      name: "Featured",
      valcheckedue: false,
      id: 3,
      value: "featured",
    },
    // ,
    // {
    //   name: "City",
    //   checked: false,
    //   id: 4,
    //   value: "city",
    // },
    // {
    //   name: "State",
    //   checked: false,
    //   id: 5,
    //   value: "state",
    // },
  ]);

  const radioOption=useMemo(()=>{
    return (
      <RadioGroup value={selectedOption}>
      {filterOption.map((e, index) => {
        return (
          <FormControlLabel
            key={e.id}
            value={e.value}
            control={<Radio />}
            label={e.name}
            checked={e.checked}
            onClick={handleOptionChange}
          />
        );
      })}
    </RadioGroup>
    )
  },[])
  return (
    <div
      style={{
        alignItems: "center",
        overflow: "auto",
        maxHeight: "100vh",
        paddingRight: "0px",
        width: "97.5%",
      }}
    >
      <Modal
        title="Confirm Deletion"
        open={isDeleteModalVisible}
        onOk={handleDeleteConfirmed}
        onCancel={hideDeleteModal}
        okText="Yes"
        cancelText="No"
      >
        Are you sure you want to delete this user?
      </Modal>

      <div className="search-container">
        <Input
          className="placeholder_search"
          prefix={
            <img src="/search.svg" style={{ width: "20px", height: "20px" }} />
          }
          placeholder="Search"
          style={{
            borderRadius: 20,
            padding: 10,
          }}
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
        />

        <img
          src="/slider.svg"
          onClick={() => setOpen(true)}
          alt="Filter"
          style={{ cursor: "pointer", marginLeft: 10 }}
        />
        {filtersApplied && (
          <Button
            style={{
              backgroundColor: "#18407D",
              color: "#fff",
              left: 10,
              borderRadius: 15,
            }}
            onClick={() => {
              clearFilters();
            }}
          >
            Clear Filters
          </Button>
        )}
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Select an Option</DialogTitle>
          <DialogContent>
            {radioOption}
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <Modal
        title="Select Date Range"
        open={isDatePickerVisible}
        onCancel={handleDatePickerClick}
        footer={null}
      >
        <RangePicker onChange={handleDateFilter} />
      </Modal>

      <Modal
        title="Select Status"
        open={isStatusModalVisible}
        onCancel={handleStatusClick}
        footer={null}
      >
        <Radio.Group onChange={handleStatusFilterChange} value={statusFilter}>
          <Radio value="active">Active</Radio>
          <Radio value="inactive">InActive</Radio>
          <Radio value="blocked">Blocked</Radio>
        </Radio.Group>
      </Modal>

      <div style={{ marginBottom: 16 }}>
        <Button onClick={() => setIsModalVisible(true)} className="btn">
          + Add Counsellor
        </Button>

        {shouldRenderViewAllButton && (
          <Button
            onClick={loadAllData}
            style={{
              color: "rgba(0, 0, 0, 1)",
              border: "none",
              marginLeft: "93.5%",
              Weight: "500",
              fontSize: "12px",
              fontFamily: "Inter, sans-serif",
              fontWeight: "bold",
            }}
          >
            View All
          </Button>
        )}
        {displayedData.some((obj) => obj?.delete) && (
          <Button
            onClick={handleDeleteAll}
            style={{
              color: "rgba(0, 0, 0, 1)",
              border: "none",
              // marginLeft: "8.5%",
              Weight: "500",
              fontSize: "12px",
              fontFamily: "Inter, sans-serif",
              fontWeight: "bold",
            }}
          >
            Delete All
          </Button>
        )}

        <Modal
          title="Add Reviews"
          open={feedbackModal}
          onCancel={() => setFeedbackModal(false)}
          onOk={() => setFeedbackModal(false)}
        >
          <div className="feedback-container">
            <div className="feedback-sub-container">
              <div>
                {rating?.map((item, index) => {
                  return (
                    <React.Fragment key={item.id}>
                      {item.star ? (
                        <GradeIcon
                          onClick={() => getRatingFromAdmin(index)}
                          style={{ color: "#F9C802", fontSize: 40 }}
                        />
                      ) : (
                        <StarBorderIcon
                          onClick={() => getRatingFromAdmin(index)}
                          style={{ color: "#F9C802", fontSize: 40 }}
                        />
                      )}
                    </React.Fragment>
                  );
                })}
              </div>

              <input
                value={feedbackComment}
                onChange={(e) => setFeebackComment(e.target.value)}
                placeholder="Add comment"
              />
            </div>
          </div>
        </Modal>
        <CounsellorForm
          toggleModal={() => setIsModalVisible(false)}
          refreshList={fetchDataFromFirestore}
          isModalVisible={isModalVisible}
        />

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    checked={
                      displayedData.every((obj) => obj?.delete) &&
                      displayedData?.length > 0
                    }
                    inputProps={{
                      "aria-labelledby": `enhanced-table-checkbox-${0}`,
                    }}
                    onClick={() => {
                      toggleDeleteSwitch();
                    }}
                  />
                </TableCell>

                <TableCell align="center">Counsellor ID</TableCell>
                <TableCell align="center">First Name</TableCell>
                <TableCell align="center">Last Name</TableCell>
                <TableCell align="center">Date Joined</TableCell>
                <TableCell align="center">Email</TableCell>
                <TableCell align="center">Phone Number</TableCell>
                <TableCell align="center">City</TableCell>
                <TableCell align="center">State</TableCell>
                <TableCell align="center">Rating</TableCell>
                <TableCell>Featured</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="table-body">
              {displayedData.map((row, index) => (
                <TableRow
                  key={row?.uuid}
                  sx={{
                    "&:last-child td, &:last-child th": {
                      background: colors.lightGray,
                    },
                  }}
                  onClick={() => {
                    navigate("/counsellor", { state: { selectedUser: row } });
                  }}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      color="primary"
                      checked={row?.delete}
                      inputProps={{
                        "aria-labelledby": `enhanced-table-checkbox-${index}`,
                      }}
                      onClick={(e) => {
                        handleMapArray(index, e);
                      }}
                    />
                  </TableCell>

                  <TableCell align="center">
                    {row?.uuid?.substring(0, 10)}
                  </TableCell>
                  <TableCell align="center">{row?.firstName}</TableCell>
                  <TableCell align="center">{row?.lastName}</TableCell>
                  <TableCell align="center">
                    {moment(row?.dateJoined).format("DD-MMM-YY")}
                  </TableCell>
                  <TableCell align="center">{row?.email}</TableCell>
                  <TableCell align="center">{row?.phone}</TableCell>
                  <TableCell align="center">{row?.city}</TableCell>
                  <TableCell align="center">{row?.state}</TableCell>
                  <TableCell align="center">
                    {/* {(row?.feedback[0].minStar + row?.feedback[0].maxStar) / 2} */}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row?.featureLoad ? (
                      <CircularProgress size={15} />
                    ) : !row?.isFeatured ? (
                      <StarBorderIcon
                        onClick={(e) =>
                          handleFeatureChange(row, index, e, "isFeatured")
                        }
                      />
                    ) : (
                      <GradeIcon
                        style={{ color: "#F9C802" }}
                        onClick={(e) =>
                          handleFeatureChange(row, index, e, "isFeatured")
                        }
                      />
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <CircleIcon
                      style={{
                        color: row?.status ? colors.green : colors.gray,
                      }}
                      fontSize="15"
                    />
                  </TableCell>
                  <TableCell
                    style={{
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <EditIcon
                      style={{ color: colors.primary }}
                      onClick={() => {
                        navigate("/counsellor", {
                          state: { selectedUser: row },
                        });
                      }}
                    />
                    <DeleteOutlineTwoToneIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        setDeleteModalVisible(true);
                        setUserToDelete(row.phone);
                      }}
                      style={{ color: colors.primary }}
                    />

                    {row?.blockLoad ? (
                      <CircularProgress size={15} />
                    ) : row?.isBlocked ? (
                      <Block
                        style={{
                          color: "red",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleFeatureChange(row, index, e, "isBlocked");
                        }}
                      />
                    ) : (
                      <Block
                        style={{
                          color: colors.primary,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleFeatureChange(row, index, e, "isBlocked");
                        }}
                      />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          style={{
            marginTop: "30px",
            color: "rgba(0, 0, 0, 1)",
            Weight: "500",
            fontSize: "10px",
            fontFamily: "Inter, sans-serif",
            fontWeight: "medium",
          }}
        >
          {" "}
          Showing {displayedData.length} from {totalRecords} data
        </div>
      </div>
    </div>
  );
};

export default CounsellorList;
